import { render, staticRenderFns } from "./settingList.vue?vue&type=template&id=e061a2c2&scoped=true&"
import script from "./settingList.vue?vue&type=script&lang=js&"
export * from "./settingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e061a2c2",
  null
  
)

export default component.exports